module['exports'] = ['visa', 'mastercard', 'link one', 'paypak'];
